var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefcaseIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/briefcase"
  }, /*#__PURE__*/React.createElement("g", {
    id: "briefcase"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.6669 45.8333H33.3335C41.7085 45.8333 43.2085 42.4792 43.646 38.3958L45.2085 21.7292C45.771 16.6458 44.3127 12.5 35.4169 12.5H14.5835C5.68771 12.5 4.22938 16.6458 4.79188 21.7292L6.35438 38.3958C6.79188 42.4792 8.29188 45.8333 16.6669 45.8333Z",
    stroke: "#8BC63E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.6665 12.5V10.8333C16.6665 7.14579 16.6665 4.16663 23.3332 4.16663H26.6665C33.3332 4.16663 33.3332 7.14579 33.3332 10.8333V12.5",
    stroke: "#8BC63E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M29.1668 27.0833V29.1667C29.1668 29.1875 29.1668 29.1875 29.1668 29.2083C29.1668 31.4792 29.146 33.3333 25.0002 33.3333C20.8752 33.3333 20.8335 31.5 20.8335 29.2292V27.0833C20.8335 25 20.8335 25 22.9168 25H27.0835C29.1668 25 29.1668 25 29.1668 27.0833Z",
    stroke: "#8BC63E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M45.104 22.9166C40.2915 26.4166 34.7915 28.5 29.1665 29.2083",
    stroke: "#8BC63E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M5.4585 23.4791C10.146 26.6875 15.4377 28.625 20.8335 29.2291",
    stroke: "#8BC63E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcaseIcon);
export default __webpack_public_path__ + "static/media/briefcase-icon.bf5534432448a7fd7fade325aa83f216.svg";
export { ForwardRef as ReactComponent };